var EmailFormTextInputView, EmailFormUserNameInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormUserNameInputView = (function(superClass) {
  extend(EmailFormUserNameInputView, superClass);

  function EmailFormUserNameInputView() {
    return EmailFormUserNameInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUserNameInputView.prototype.tagName = 'li';

  EmailFormUserNameInputView.prototype.events = {
    'keyup .user_name_input': 'validateUserName'
  };

  EmailFormUserNameInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".user_name_input";
    return this.template = {
      user_name_input_template: true
    };
  };

  EmailFormUserNameInputView.prototype.isInputValid = function() {
    var ref, ref1, ref2;
    if (!this.isInputElementPresent()) {
      return true;
    }
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormUserNameInputView.prototype.isInputElementPresent = function() {
    var ref;
    return ((ref = this.getInputHtmlElement()) != null ? ref.length : void 0) > 0;
  };

  EmailFormUserNameInputView.prototype.validateUserName = function() {
    this.isInputValid();
    return this.validateEmailForm();
  };

  EmailFormUserNameInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_name = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.call(this, data);
    }
  };

  return EmailFormUserNameInputView;

})(EmailFormTextInputView);

module.exports = EmailFormUserNameInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML3VzZXJfbmFtZV9pbnB1dF92aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2VtYWlsX2Zvcm0vSU5UTC91c2VyX25hbWVfaW5wdXRfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxrREFBQTtFQUFBOzs7QUFBQSxzQkFBQSxHQUF5QixPQUFBLENBQVEsb0NBQVI7O0FBRW5COzs7Ozs7O3VDQUNKLE9BQUEsR0FBUzs7dUNBRVQsTUFBQSxHQUNFO0lBQUEsd0JBQUEsRUFBMEIsa0JBQTFCOzs7dUNBRUYsVUFBQSxHQUFZLFNBQUE7SUFDVixzQkFBc0IsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQW5DLENBQXlDLElBQXpDLEVBQStDLFNBQS9DO0lBQ0EsSUFBQyxDQUFBLFNBQUQsR0FBYTtXQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7TUFBQyx3QkFBQSxFQUEwQixJQUEzQjs7RUFIRjs7dUNBS1osWUFBQSxHQUFjLFNBQUE7QUFDWixRQUFBO0lBQUEsSUFBQSxDQUFtQixJQUFDLENBQUEscUJBQUQsQ0FBQSxDQUFuQjtBQUFBLGFBQU8sS0FBUDs7eUhBQ3FDLENBQUUsa0NBQXZDLEdBQWdEO0VBRnBDOzt1Q0FJZCxxQkFBQSxHQUF1QixTQUFBO0FBQ3JCLFFBQUE7NERBQXNCLENBQUUsZ0JBQXhCLEdBQWlDO0VBRFo7O3VDQUd2QixnQkFBQSxHQUFrQixTQUFBO0lBQ2hCLElBQUMsQ0FBQSxZQUFELENBQUE7V0FDQSxJQUFDLENBQUEsaUJBQUQsQ0FBQTtFQUZnQjs7dUNBSWxCLGFBQUEsR0FBZSxTQUFDLElBQUQ7SUFDYixJQUFHLElBQUMsQ0FBQSxZQUFELENBQUEsQ0FBSDtNQUNFLElBQUksQ0FBQyxTQUFMLEdBQWlCLElBQUMsQ0FBQSxTQUFELENBQUE7YUFDakIsc0JBQXNCLENBQUEsU0FBRSxDQUFBLGFBQWEsQ0FBQyxJQUF0QyxDQUEyQyxJQUEzQyxFQUFpRCxJQUFqRCxFQUZGOztFQURhOzs7O0dBdEJ3Qjs7QUEyQnpDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
